import { useAppSelector } from 'app/hooks';
import { useStepTipSequence } from 'hooks/use-step-tip-sequence';
import { useMemo } from 'react';
import { getComparisonModalTipSections } from 'utils/choose-systems-tips';

export default function ComparisonModalTips() {
  const textKeys = useAppSelector((state) => state.data.textKeys);
  const sections = useMemo(
    () => getComparisonModalTipSections(textKeys),
    [textKeys]
  );

  useStepTipSequence({
    sections,
    currentSectionId: 'choose_systems_comparison',
    currentStepComplete: false
  });

  return null;
}
